import lodash from 'lodash'

const throttle = lodash.throttle
const _ = lodash
const ld = lodash

export { throttle, _, ld, lodash }
